import { render, staticRenderFns } from "./BlocklyHome.vue?vue&type=template&id=0154141a&scoped=true&"
import script from "./BlocklyHome.vue?vue&type=script&lang=js&"
export * from "./BlocklyHome.vue?vue&type=script&lang=js&"
import style0 from "./BlocklyHome.vue?vue&type=style&index=0&id=0154141a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0154141a",
  null
  
)

export default component.exports